export const TestimonialsTableColumns = (isArabic) => [
    { id: 'client_name', label: isArabic ? 'العميل' : 'Client Name', align: 'start' },
    { id: 'rate', label: isArabic ? 'التقييم' : 'Rate', align: 'center' },
    { id: 'is_active', label: isArabic ? 'الحالة' : 'Status', align: 'center' },
    { id: 'sort_order', label: isArabic ? 'الترتيب' : 'Sort Order', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];
